export default [
  {
    path: '/:locale([en/]*)?/notfound',
    name: 'Notfound',
    component: () => import('@/views/NotFound'),
    meta: {
      language: false,
      sitemap: { ignoreRoute: true }
    }
  },
  {
    path: '*',
    name: 'Error',
    component: () => import('@/views/Error'),
    meta: {
      language: false,
      sitemap: { ignoreRoute: true }
    }
  }
]
